// import React from "react";

// import FBNStructure from "../FBNStructure/FBNStructure";
// import styles from "../../styles/Dashboard.module.scss";
// import { reportScreensMap } from "../../components/ReportScreens/ReportScreens";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   ResponsiveContainer,
//   // CartesianGrid,
//   Tooltip,
//   // Legend,
// } from "recharts";
// import { useState } from "react";
// import { useEffect } from "react";
// import Dropdown from "../../components/Dropdown/Dropdown";
// import Chart from "react-google-charts";
// import { useQuery } from "@tanstack/react-query";
// import axios from "axios";
// import Loader from "../../assets/images/fidelityLoader.gif";
// import { DonwloadIcon, LoadingIcon } from "../../assets/icons";
// import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";

// const API_ENDPOINT =
//   "https://firstbankapi-dpf7ajceb9czfbe2.francecentral-01.azurewebsites.net/api/api";
// let customerActivityCurrentPreviousMonth;

// const Dashboard = () => {
//   // const activeReport = useSelector(
//   //   (state) => state?.dashboardActivePage?.activeReport
//   // );

//   const currentYear = new Date().getFullYear();
//   const DropdownYear = [{ value: 2025 }, { value: 2026 }];

//   const [barChartStyling, setBarChartStyling] = useState(1000);

//   useEffect(() => {
//     const handleResize = () => {
//       const value = window.innerWidth;
//       if (value > 888) {
//         setBarChartStyling(value - 300);
//       } else {
//         setBarChartStyling(value - 50);
//       }
//     };

//     window.addEventListener("resize", handleResize);

//     handleResize();

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const monthData = [
//     { value: "Jan", monthNumber: "01" },
//     { value: "Feb", monthNumber: "02" },
//     { value: "Mar", monthNumber: "03" },
//     { value: "Apr", monthNumber: "04" },
//     { value: "May", monthNumber: "05" },
//     { value: "Jun", monthNumber: "06" },
//     { value: "Jul", monthNumber: "07" },
//     { value: "Aug", monthNumber: "08" },
//     { value: "Sep", monthNumber: "09" },
//     { value: "Oct", monthNumber: "10" },
//     { value: "Nov", monthNumber: "11" },
//     { value: "Dec", monthNumber: "12" },
//   ];

//   /////////CUSTOMER ACTIVITIES START////////////
//   const fetchCustomerActivity = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_FIRSTBANK_BASEURL}/customer_activity`,
//         {
//           headers: {
//             //  Accept: "*/*",
//             "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//           },
//         }
//       );

//       return response?.data?.success;
//     } catch (error) {
//       throw error;
//     }
//   };

//   const {
//     data: customerActivityData,
//     isLoading: isLoadingCustomerActivity,
//     refetch: refetchCustomerActivity,
//   } = useQuery({
//     queryKey: ["customer-activity-summary"],
//     queryFn:()=> fetchCustomerActivity(),
//   });

//   ////////// CUSTOMER ACTIVITIES END /////////

//   ////////////// POINT SUMMARY API AND CUSTOMER ACTIVITY SUMMARY API///////////

//   // const fetchPointSummary = async () => {
//   //   const params = {
//   //     api: "get_point_summary_data",
//   //   };
//   //   const response = await axios.get(API_ENDPOINT, {
//   //     params,
//   //     headers: {
//   //       Token: process.env.REACT_APP_FIRSTBANK_TOKEN,
//   //     },
//   //   });
//   //   return response?.data?.data?.cards;
//   // };

//   // const {
//   //   data: pointSummaryData,
//   //   isLoading: isLoadingPointSummary,
//   //   refetch: refetchPointSummary,
//   // } = useQuery("Get Point Summary", () => fetchPointSummary());
//   ////////////// POINT SUMMARY API AND CUSTOMER ACTIVITY SUMMARY API END///////////

//   ////////////// API CALL FOR Transaction Report/////////////////////////
//   // const [dataYear, setDataYear] = useState(DropdownYear[0]?.value);
//   const [dataYear, setDataYear] = useState(currentYear);

//   const [reportError, setReportError] = useState("");
//   const fetchData = async (year = "") => {
//     const params = {
//       // api: "get_transaction_data",
//       year: year || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/transaction_amount`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     if (response?.data?.status === 0) {
//       setReportError(response?.data?.message);
//     }

//     return response?.data;
//   };

//   const {
//     data: transactionReport,
//     isLoading,
//     isError,
//     refetch,
//   } = useQuery({
//     queryKey: ["transactionData", dataYear],
//     queryFn: () => fetchData(dataYear),
//     enabled: !!dataYear, // Only fetch when dataYear is available
//     staleTime: 1000 * 60 * 5, // 5 minutes
//     refetchOnWindowFocus: false, // Prevent refetch when switching tabs
//   });

//   useEffect(() => {
//     refetch();
//   }, [dataYear]);

//   ////////////Transaction Report End ////////////

/////////////////////// EMAIL DURABILITY (AGGREGATE EMAIL HISTORY) ///////////////////////
  // const fetchAggregateEmailsHistory = async () => {
  //   const response = await axios.get(
  //     `${process.env.REACT_APP_FIRSTBANK_BASEURL}/aggregate_emails_history`,
  //     {
  //       headers: {
  //         "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
  //       },
  //     }
  //   );
  //   return response?.data?.data;
  // };

  // const {
  //   data: emailDurabilityData,
  //   isLoading: isLoadingEmailDurability,
  //   isError: isErrorEmailDurability,
  // } = useQuery({
  //   queryKey: ["aggregate-emails-history"],
  //   queryFn: fetchAggregateEmailsHistory,
  //   staleTime: 1000 * 60 * 5,
  //   refetchOnWindowFocus: false,
  // });

//   /////////////////////////////////// Point Accumulation Report/////////////////////////////////////
//   // const [pointAccumulationReportYear, setPointAccumulationReportYear] =
//   //   useState(DropdownYear[0]?.value);
//   const [pointAccumulationReportYear, setPointAccumulationReportYear] = useState(currentYear);

//   const fetchPointAccumulationReportData = async (year = "") => {
//     const params = {
//       // api: "get_point_accumulation_data",
//       year: year || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/points_accumulation`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     return response?.data;
//   };

//   const {
//     data: pointAccumulationReport,
//     isLoading: isLoadingPointAccumulation,
//     isError: isErrorPointAccumulation,
//     refetch: refetchPointAccumulation,
//   } = useQuery({
//     queryKey: ["point-accumulation-data", pointAccumulationReportYear],
//     queryFn: () =>
//       fetchPointAccumulationReportData(pointAccumulationReportYear),
//     enabled: !!pointAccumulationReportYear, // ensures query only runs when year is defined
//     staleTime: 1000 * 60 * 5, // optional: cache data for 5 mins
//     refetchOnWindowFocus: false, // optional: prevents refetch when tab regains focus
//   });



//   // const handlePointAccumulationYearToggle = () => {
//   //   setPointAccumulationReportYear(pointAccumulationReportYear);
//   //   refetchPointAccumulation();
//   // };

//   useEffect(() => {
//     refetchPointAccumulation();
//   }, [pointAccumulationReportYear]);

//   /////////POINT ACCUMULATION REPORT END ///////////

//   ////////////// STATUS CARDS //////////////
// const fetchPointToCashStatus = async () => {
//   const response = await axios.get(
//     `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_point_to_cash_status`,
//     { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
//   );
//   return response?.data;
// };

// const fetchBapRedemptionStatus = async () => {
//   const response = await axios.get(
//     `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_bap_redemption_status`,
//     { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
//   );
//   return response?.data;
// };

// const fetchAcquisitionStatus = async () => {
//   const response = await axios.get(
//     `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_acquisition_processing_status`,
//     { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
//   );
//   return response?.data;
// };

// const fetchEmailProcessingStatus = async () => {
//   const response = await axios.get(
//     `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_email_processing_status`,
//     { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
//   );
//   return response?.data;
// };

// const { data: pointToCashStatus, isLoading: isLoadingPointToCash } = useQuery({
//   queryKey: ["pointToCashStatus"],
//   queryFn: fetchPointToCashStatus,
// });

// const { data: bapRedemptionStatus, isLoading: isLoadingBapRedemption } = useQuery({
//   queryKey: ["bapRedemptionStatus"],
//   queryFn: fetchBapRedemptionStatus,
// });

// const { data: acquisitionStatus, isLoading: isLoadingAcquisition } = useQuery({
//   queryKey: ["acquisitionStatus"],
//   queryFn: fetchAcquisitionStatus,
// });

// const { data: emailProcessingStatus, isLoading: isLoadingEmailProcessing } = useQuery({
//   queryKey: ["emailProcessingStatus"],
//   queryFn: fetchEmailProcessingStatus,
// });
// ////////////// STATUS CARDS END //////////////


//   /////////////////////// Channel Usage Summary (Pie Chart)//////////////////////////////

//   const options = {
//     // title: 'My Daily Activities',
//     // tooltip: {trigger: 'selection'}, //To hide tooltip
//     // legend: {position: 'none'}, Chart options name.
//     pieHole: 0.5,
//     is3D: false,

//     colors: ["#0E237D", "#0D99FF", "#4FC143", "#27824D", "#989898"],
//   };
//   // const [channelUssageYear, setChannelUssageYear] = useState(
//   //   DropdownYear[0]?.value
//   // );
//   const [channelUssageYear, setChannelUssageYear] = useState(currentYear);

//   const [channelUssageError, setChannelUssageError] = useState("");

//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth();
//   let previousMonth;
//   console.log("currentMonth 123", currentMonth)

//   if (currentMonth === 0) {
//     previousMonth = 11;
//   } else {
//     // previousMonth = currentMonth - 1;
//     previousMonth = currentMonth  // PREVIOUS MONTH NOW RETURNS CURRENT MONTH AS DEFAULT MONTH SHOULD BE CURRENT MONTH;
//     console.log("isPREV", previousMonth )
//   }

//   const [channelUssageMonthNumber, setChannelUssageMonthNumber] =
//     useState(previousMonth);



//   const currentMonthName = monthData[channelUssageMonthNumber];
//     console.log("isMONTH", channelUssageMonthNumber, currentMonthName )


//   const [channelUssageMonth, setChannelUssageMonth] = useState(
//     currentMonthName?.value
//   );

//   const queryMonth = monthData.filter(
//     (each) => each.value === channelUssageMonth
//   );
//   const fetchChannelUssageData = async (year = "", month = "") => {
//     const params = {
//       // api: "get_channel_summary_data",
//       year: year || undefined,
//       month: month || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/channel_summary`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     if (response.data.status === 0) {
//       setChannelUssageError(response?.data.message);
//     }

//     return response?.data?.output;
//   };

//   // const {
//   //   data: channelUssageData,
//   //   isLoading: isLoadingChannelData,
//   //   isError: isErrorChannelData,
//   //   refetch: refetchChannelData,
//   // } = useQuery(["channelUssageData", channelUssageYear, queryMonth], () =>
//   //   fetchChannelUssageData(channelUssageYear, queryMonth[0]?.monthNumber)
//   // );

//   /////////////////////// Channel Usage Summary (Pie Chart) End//////////////////////////////
//   // ////////////////////////// Redemption Chart ///////////////////////////
//   const RedemptionOptions = {
//     tooltip: { trigger: "none" },
//     pieHole: 0.5,
//     is3D: false,
//     colors: ["#FF6B6A", "#FFCD29", "#7B61FF", "#E1E7FF", "#0D99FF"],
//   };

//   // const [redemptionYear, setRedemptionYear] = useState(DropdownYear[0]?.value);
//   const [redemptionYear, setRedemptionYear] = useState(currentYear);

//   const redemptionDate = new Date();
//   const redemptionCurrentMonth = redemptionDate.getMonth();
//   let redemptionPreviousMonth;

//   if (redemptionCurrentMonth === 0) {
//     redemptionPreviousMonth = 11;
//   } else {
//     redemptionPreviousMonth = redemptionCurrentMonth;
//   }

//   const [redemptionMonthNumber, setRedemptionMonthNumber] = useState(
//   redemptionPreviousMonth
//   );

//   const redemptionMonthName = monthData[redemptionMonthNumber];

//   const [redemptionMonth, setRedemptionMonth] = useState(
//     redemptionMonthName?.value
//   );

//   const redemptionQueryMonth = monthData.filter(
//     (each) => each.value === redemptionMonth
//   );

//   const fetchRedemptionData = async (year = "", month = "") => {
//     const params = {
//       // api: "get_redemption_report",
//       year: year || undefined,
//       month: month || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/redemption_report`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     return response?.data?.output;
//   };

//   const {
//     data: channelUssageData,
//     isPending: isLoadingChannelData,
//     isError: isErrorChannelData,
//     refetch: refetchChannelData,
//   } = useQuery({
//     queryKey: [
//       "channelUsageData",
//       channelUssageYear,
//       queryMonth?.[0]?.monthNumber,
//     ],
//     queryFn: () =>
//       fetchChannelUssageData(channelUssageYear, queryMonth?.[0]?.monthNumber),
//     enabled: !!channelUssageYear && !!queryMonth?.[0]?.monthNumber,
//   });

//   const {
//     data: redemptionData,
//     isPending: isLoadingRedemption,
//     isError: isErrorRedemption,
//     refetch: refetchRedemption,
//   } = useQuery({
//     queryKey: [
//       "redemptionData",
//       redemptionYear,
//       redemptionQueryMonth?.[0]?.monthNumber,
//     ],
//     queryFn: () =>
//       fetchRedemptionData(
//         redemptionYear,
//         redemptionQueryMonth?.[0]?.monthNumber
//       ),
//     enabled: !!redemptionYear && !!redemptionQueryMonth?.[0]?.monthNumber,
//   });

//   // ////////////////////////// Redemption Chart End /////////////////////////

//   /////////////////////////////////// Enrollment Report/////////////////////////////////////
//   // const [enrolmentReportYear, setEnrolmentReportYear] = useState(
//   //   DropdownYear[0]?.value
//   // );
//   const [enrolmentReportYear, setEnrolmentReportYear] = useState(currentYear);

//   const fetchEnrolmentReportData = async (year = "") => {
//     const params = {
//       // api: "get_enrollment_data",
//       year: year || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/enrollment_data`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     return response?.data;
//   };

//   console.log("channelUssageData", channelUssageData);

//   const {
//     data: enrolmentReport,
//     isPending: isLoadingEnrolment,
//     isError: isErrorEnrolment,
//     refetch: refetchEnrolment,
//   } = useQuery({
//     queryKey: ["enrolmentData", enrolmentReportYear],
//     queryFn: () => fetchEnrolmentReportData(enrolmentReportYear),
//     enabled: !!enrolmentReportYear,
//   });

//   useEffect(() => {
//     refetchEnrolment();
//   }, [enrolmentReportYear]);

//   //////////// Enrolment Report End /////////////

//   /////////////// Expired & Forfeited Points Chart //////////////////////////////
//   const expiredPointOption = {
//     pieHole: 0.5,
//     is3D: false,
//     colors: ["#747272", "#0D99FF"],
//   };

//   // const [expiredPointYear, setExpiredPointYear] = useState(
//   //   DropdownYear[0]?.value
//   // );
//   const [expiredPointYear, setExpiredPointYear] = useState(currentYear);

//   const expiredPointCurrentDate = new Date();
//   const expiredPointCurrentMonth = expiredPointCurrentDate.getMonth();
//   let expiredPointCurrentPreviousMonth;

//   if (expiredPointCurrentMonth === 0) {
//     expiredPointCurrentPreviousMonth = 11;
//   } else {
//     expiredPointCurrentPreviousMonth = expiredPointCurrentMonth - 1;
//   }

//   const [expiredPointMonthNumber, setExpiredPointMonthNumber] = useState(
//     expiredPointCurrentPreviousMonth
//   );

//   const expiredPointMonthName = monthData[expiredPointMonthNumber];

//   const [expiredPointMonth, setExpiredPointMonth] = useState(
//     expiredPointMonthName?.value
//   );

//   const expiredPointQueryMonth = monthData.filter(
//     (each) => each.value === expiredPointMonth
//   );

//   const fetchExpiredPointData = async (year = "", month = "") => {
//     const params = {
//       //api: "get_expired_forfeited_points_report",
//       year: year || undefined,
//       month: month || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/point_report`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     // if (response.data.status === 0) {
//     //   setChannelUssageError(response?.data.message);
//     // }

//     return response?.data?.output;
//   };

//   const {
//     data: expiredPointData,
//     isPending: isLoadingExpiredPoint,
//     isError: isErrorExpiredPoint,
//     refetch: refetchExpiredPoint,
//   } = useQuery({
//     queryKey: [
//       "expiredPointData",
//       expiredPointYear,
//       expiredPointQueryMonth?.[0]?.monthNumber,
//     ],
//     queryFn: () =>
//       fetchExpiredPointData(
//         expiredPointYear,
//         expiredPointQueryMonth?.[0]?.monthNumber
//       ),
//     enabled: !!expiredPointYear && !!expiredPointQueryMonth?.[0]?.monthNumber,
//   });

//   /////////////// Expired & Forfeited Points Chart End //////////////////////////////

//   // get_channel_summary_data;

//   //////////////////////// Customer Activity Summary////////////////////////////

//   // const customerActivityOption = {

//   //   pieHole: 0.5,
//   //   is3D: false,
//   //   colors: ['#0E237D', '#4FC143'],
//   // };

//   // const [customerActivityYear, setCustomerActivityYear] = useState(
//   //   DropdownYear[0]?.value
//   // );
//   const [customerActivityYear, setCustomerActivityYear] = useState(currentYear);

//   const customerActivityCurrentDate = new Date();
//   const customerActivityCurrentMonth = customerActivityCurrentDate.getMonth();

//   if (customerActivityCurrentMonth === 0) {
//     customerActivityCurrentPreviousMonth = 11;
//   } else {
//     customerActivityCurrentPreviousMonth = customerActivityCurrentMonth - 1;
//   }

//   const [customerActivityMonthNumber, setCustomerActivityMonthNumber] =
//     useState(customerActivityCurrentPreviousMonth);

//   const customerActivityMonthName = monthData[customerActivityMonthNumber];

//   const [customerActivityMonth, setCustomerActivityMonth] = useState(
//     customerActivityMonthName?.value
//   );

//   const customerActivityQueryMonth = monthData.filter(
//     (each) => each.value === customerActivityMonth
//   );

//   // const fetchCustomerActivityData = async (year = '', month = '') => {
//   //   const params = {
//   //     api: 'get_customers_activities',
//   //     year: year || undefined,
//   //     month: month || undefined,
//   //   };

//   //   const response = await axios.get(API_ENDPOINT, {
//   //     params,
//   //     headers: {
//   //       Token: process.env.REACT_APP_FIRSTBANK_TOKEN,
//   //     },
//   //   });

//   //   return response?.data?.data[0];
//   // };

//   // const {
//   //   data: customerActivityData,
//   //   isLoading: isLoadingCustomerActivity,
//   //   isError: isErrorCustomerActivity,
//   //   refetch: refetchCustomerActivity,
//   // } = useQuery(
//   //   [
//   //     'Customer Activity Data',
//   //     customerActivityYear,
//   //     customerActivityQueryMonth,
//   //   ],
//   //   () =>
//   //     fetchCustomerActivityData(
//   //       customerActivityYear,
//   //       customerActivityQueryMonth[0]?.monthNumber,
//   //     ),
//   // );

//   // console.log(customerActivityData, 'customerActivityData');

//   ///////////////////// Customer Delivery Chart////////////////////////////////
//   const customerDeliveryOption = {
//     pieHole: 0.5,
//     is3D: false,
//     colors: ["#4FC143", "#FF005F"],
//   };

//   // const [customerDeliveryYear, setCustomerDeliveryYear] = useState(
//   //   DropdownYear[0]?.value
//   // );
//   const [customerDeliveryYear, setCustomerDeliveryYear] = useState(currentYear);

//   const customerDeliveryDate = new Date();
//   const customerDeliveryCurrentMonth = customerDeliveryDate.getMonth();
//   let customerDeliveryPreviousMonth;

//   if (customerDeliveryCurrentMonth === 0) {
//     customerDeliveryPreviousMonth = 11;
//   } else {
//     customerDeliveryPreviousMonth = customerDeliveryCurrentMonth - 1;
//   }

//   const [customerDeliveryMonthNumber, setCustomerDeliveryMonthNumber] =
//     useState(customerActivityCurrentPreviousMonth);

//   const customerDeliveryMonthName = monthData[customerDeliveryMonthNumber];

//   const [customerDeliveryMonth, setCustomerDeliveryMonth] = useState(
//     customerDeliveryMonthName?.value
//   );

//   const customerDeliveryQueryMonth = monthData.filter(
//     (each) => each.value === customerDeliveryMonth
//   );

//   const fetchCustomerDelivery = async (year = "", month = "") => {
//     const params = {
//       // api: "get_customers_delivery_report",
//       year: year || undefined,
//       month: month || undefined,
//     };

//     const response = await axios.get(
//       `${process.env.REACT_APP_FIRSTBANK_BASEURL}/customer_delivery`,
//       {
//         params,
//         headers: {
//           "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
//         },
//       }
//     );

//     return response?.data?.output;
//   };

//   const {
//     data: customerDeliveryData,
//     isPending: customerDeliveryLoading,
//     isError: customerDeliveryError,
//     refetch: refetchCustomerDelivery,
//   } = useQuery({
//     queryKey: [
//       "customerDeliveryData",
//       customerDeliveryYear,
//       customerDeliveryQueryMonth?.[0]?.monthNumber,
//     ],
//     queryFn: () =>
//       fetchCustomerDelivery(
//         customerDeliveryYear,
//         customerDeliveryQueryMonth?.[0]?.monthNumber
//       ),
//     enabled:
//       !!customerDeliveryYear && !!customerDeliveryQueryMonth?.[0]?.monthNumber,
//   });

//   // // map a screen to a component
//   // const ReportComponent = reportScreensMap[activeReport];

// // Utility function to format a Date as YYYY-MM-DD
// const formatDate = (date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
//   const day = String(date.getDate()).padStart(2, "0");
//   return `${year}-${month}-${day}`;
// };

// const [expectedPointsDate, setExpectedPointsDate] = useState(formatDate(new Date()));

//   // Fetch function for the endpoint
//   const fetchTotalExpectedPoints = async (date) => {
//     try {
//       const response = await axios.get(
//         `https://firstbank-live-perx-instance-f9g2dfakgdgmgaar.francecentral-01.azurewebsites.net/scripts/total_expected_points.php`,
//         { params: { date } }
//       );
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   };
// // const fetchTotalExpectedPoints = async (date) => {
// //     try {
// //       const response = await axios.get(
// //         `https://fbn.perxclm5.com/scripts/total_expected_points.php`,
// //         { params: { date } }
// //       );
// //       return response.data;
// //     } catch (error) {
// //       throw error;
// //     }
// //   };


//   // useQuery for fetching data
//   const {
//     data: expectedPointsData,
//     isLoading: isLoadingExpectedPoints,
//     refetch: refetchExpectedPoints,
//   } = useQuery({
//     queryKey: ["total-expected-points", expectedPointsDate],
//     queryFn: () => fetchTotalExpectedPoints(expectedPointsDate),
//     enabled: !!expectedPointsDate, // only fetch if date exists
//   });

//   // Refetch when date changes
//   useEffect(() => {
//     refetchExpectedPoints();
//   }, [expectedPointsDate]);


//   return (
//      <div>
//           <div className={styles.topCard}>

//             <div className={styles.leftCardContainer}>
//               <div className={styles.barChartTop}>
//                 <div>
//                 <h4>Customer Activity Summary</h4>
//                 <p>View all customer activity on the platform</p>
//                 </div>
//               </div>
//               <div className={styles.cardContainer}>
//                 <div className={styles.CASCard1}>
//                   <p>Logged In Customers</p>
//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                       customerActivityData?.loggedin_count?
//                       parseInt(
//                         customerActivityData?.loggedin_count
//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>
//                 <div className={styles.CASCard2}>
//                   <p>Customers not logged In</p>
//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                       customerActivityData?.loggedout_count ?
//                       parseInt(
//                         customerActivityData?.loggedout_count
//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>
//                 <div className={styles.CASCard3}>
//                   <p>Customers who redeemed</p>
//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                           customerActivityData?.redeemed_count ?
//                       parseInt(
//                         customerActivityData?.redeemed_count
//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>
//                 <div className={styles.CASCard4}>
//                   <p>Customers yet to redeem</p>
//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                        customerActivityData?.not_redeemed_count ?
//                       parseInt(
//                         customerActivityData?.not_redeemed_count
//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>
//               </div>
//             </div>

//             <div className={styles.rightCardContainer}>
//               <div className={styles.barChartTop}>
//                 <div><h4>Points Summary</h4>
//                 <p>View total point summary</p>
//                 </div>
//                  <input
//                   type="date"
//                   id="expectedPointsDate"
//                   value={expectedPointsDate}
//                   onChange={(e) => setExpectedPointsDate(e.target.value)}
//                   className={styles.dateInput}
//                 />
//               </div>

//               <div className={styles.cardContainer}>
//                 <div className={styles.CASCard5}>
//                   <p>Total Points Earned</p>
//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                       customerActivityData?.total_gained_points ?
//                       parseInt(
//                        customerActivityData?.total_gained_points
//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>

//                 <div className={styles.CASCard6}>

//                   <p>Total points Redeemed</p>

//                   <h4>
//                     {isLoadingCustomerActivity ? (
//                       <LoadingIcon />
//                     ) : (
//                        customerActivityData?.total_points_issued ?
//                       parseInt(


//                           customerActivityData?.total_points_issued

//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>

//                 <div className={styles.CASCard7}>

//                   <p>Total points Expected (Daily)</p>

//                   <h4>
//                     {isLoadingExpectedPoints ? (
//                       <LoadingIcon />
//                     ) : (
//                        expectedPointsData?.Total_expected_points ?
//                       parseInt(


//                           expectedPointsData?.Total_expected_points

//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>

//                 <div className={styles.CASCard8}>

//                   <p>Total points Issued (Daily)</p>

//                   <h4>
//                     {isLoadingExpectedPoints ? (
//                       <LoadingIcon />
//                     ) : (
//                        expectedPointsData?.Total_accumulated_points ?
//                       parseInt(


//                           expectedPointsData?.Total_accumulated_points

//                       ).toLocaleString()
//                       : 0
//                     )}
//                   </h4>
//                 </div>

//                 <div className={styles.CASCard9}>
//                   <p>Total Transactions Dumped (Daily)</p>
//                   <h4>
//                     {isLoadingExpectedPoints ? (
//                       <LoadingIcon />
//                     ) : (
//                       expectedPointsData?.Total_transaction_dumped
//                         ? parseInt(expectedPointsData?.Total_transaction_dumped).toLocaleString()
//                         : 0
//                     )}
//                   </h4>
//                 </div>

//                 <div className={styles.CASCard10}>
//                   <p>Total Transactions Processed (Daily)</p>
//                   <h4>
//                     {isLoadingExpectedPoints ? (
//                       <LoadingIcon />
//                     ) : (
//                       expectedPointsData?.Total_processed_transactions
//                         ? parseInt(expectedPointsData?.Total_processed_transactions).toLocaleString()
//                         : 0
//                     )}
//                   </h4>
//                 </div>

//               </div>

//             </div>

//           </div>


//             {/* ===== STATUS CARDS ===== */}
// <div className={styles.statusCardsContainer}>
//   <div className={styles.barChartTop}>
//     <h4>Processing Status</h4>
//     <p>Live status of all background processes</p>
//   </div>
//   <div className={styles.statusCardsInner}>

//     <div className={styles.statusCard}>
//       <p className={styles.statusCardTitle}>Points to Cash Status</p>
//       {isLoadingPointToCash ? (
//         <LoadingIcon />
//       ) : (
//         <span className={
//           pointToCashStatus?.toLowerCase() === "active"
//             ? styles.statusBadgeActive
//             : styles.statusBadgeInactive
//         }>
//           {pointToCashStatus ?? "N/A"}
//         </span>
//       )}
//     </div>

//     <div className={styles.statusCard}>
//       <p className={styles.statusCardTitle}>BAP Redemption Status</p>
//       {isLoadingBapRedemption ? (
//         <LoadingIcon />
//       ) : (
//         <span className={
//           bapRedemptionStatus?.toLowerCase() === "active"
//             ? styles.statusBadgeActive
//             : styles.statusBadgeInactive
//         }>
//           {bapRedemptionStatus ?? "N/A"}
//         </span>
//       )}
//     </div>

//     <div className={styles.statusCard}>
//       <p className={styles.statusCardTitle}>Acquisition Processing Status</p>
//       {isLoadingAcquisition ? (
//         <LoadingIcon />
//       ) : (
//         <span className={
//           acquisitionStatus?.toLowerCase() === "active"
//             ? styles.statusBadgeActive
//             : styles.statusBadgeInactive
//         }>
//           {acquisitionStatus ?? "N/A"}
//         </span>
//       )}
//     </div>

//     <div className={styles.statusCard}>
//       <p className={styles.statusCardTitle}>Email Processing Status</p>
//       {isLoadingEmailProcessing ? (
//         <LoadingIcon />
//       ) : (
//         <span className={
//           emailProcessingStatus?.toLowerCase() === "active"
//             ? styles.statusBadgeActive
//             : styles.statusBadgeInactive
//         }>
//           {emailProcessingStatus ?? "N/A"}
//         </span>
//       )}
//     </div>

//   </div>
// </div>
// {/* ===== STATUS CARDS END ===== */}

// {/* EMAIL DURABILITY REPORT */}
//       <div className={styles.barChartContainer}>
//         <div className={styles.barChartTopContainer}>
//           <div className={styles.barChartTop}>
//             <h4>Email Durability</h4>
//             <p>View aggregate email history breakdown by day</p>
//           </div>
//         </div>

//         {isLoadingEmailDurability ? (
//           <div className={styles.loaderContainer}>
//             <img src={Loader} alt="loader" />
//           </div>
//         ) : emailDurabilityData && emailDurabilityData.length > 0 ? (
//           <>
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart
//                 margin={{ top: 10, right: 10, left: 20, bottom: 5 }}
//                 data={emailDurabilityData}
//               >
//                 <XAxis dataKey="day" />
//                 <YAxis />
//                 {/* shared={false} ensures tooltip only shows the single bar being hovered */}
//                 <Tooltip shared={false} />
//                 <Legend />
//                 <Bar
//                   dataKey="total_expected"
//                   name="Total Email Count"
//                   fill="#FACC15"
//                 />
//                 <Bar
//                   dataKey="total_sent"
//                   name="Email Sent"
//                   fill="#22C55E"
//                 />
//                 <Bar
//                   dataKey="failed"
//                   name="Email Failed"
//                   fill="#EF4444"
//                 />
//               </BarChart>
//             </ResponsiveContainer>

//             {/* COLOR GUIDE / LEGEND */}
//             {/* <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: "24px",
//                 marginTop: "16px",
//                 paddingTop: "12px",
//                 borderTop: "1px solid #E5E7EB",
//               }}
//             >
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span
//                   style={{
//                     width: "14px",
//                     height: "14px",
//                     backgroundColor: "#FACC15",
//                     borderRadius: "3px",
//                     display: "inline-block",
//                   }}
//                 ></span>
//                 <span style={{ fontSize: "13px", color: "#4B5563" }}>
//                   Total Email Count
//                 </span>
//               </div>
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span
//                   style={{
//                     width: "14px",
//                     height: "14px",
//                     backgroundColor: "#22C55E",
//                     borderRadius: "3px",
//                     display: "inline-block",
//                   }}
//                 ></span>
//                 <span style={{ fontSize: "13px", color: "#4B5563" }}>
//                   Email Sent
//                 </span>
//               </div>
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span
//                   style={{
//                     width: "14px",
//                     height: "14px",
//                     backgroundColor: "#EF4444",
//                     borderRadius: "3px",
//                     display: "inline-block",
//                   }}
//                 ></span>
//                 <span style={{ fontSize: "13px", color: "#4B5563" }}>
//                   Email Failed
//                 </span>
//               </div>
//             </div> */}
//           </>
//         ) : (
//           <div className={styles.nodataContainer}>
//             <h1>No Data</h1>
//           </div>
//         )}
//       </div>


//           {/* <div className={styles.barChartContainer}>
//             <div className={styles.barChartTopContainer}>
//               <div className={styles.barChartTop}>
//                 <h4>Incremental Income Report</h4>
//                 <p>View all transaction amount made by customer</p>
//               </div>
//               <div className={styles.incrementalReportContainer}>
//                 <Link
//                   target="_blank"
//                   to="https://greenrewards.perxclm.com/monthly_transaction_report.php"
//                 >
//                   <button className={styles.incrementalBTN}>
//                     <DonwloadIcon /> Download Data
//                   </button>
//                 </Link>

//                 <Dropdown
//                   data={DropdownYear}
//                   rangeValue={dataYear}
//                   setRangeValue={setDataYear}
//                 />
//               </div>
//             </div>
//             {!isLoading && (
//             <div className={styles.errorMessageStyling}>{reportError}</div>
//           )}
//             {isLoading ? (
//               <div className={styles.loaderContainer}>
//                 <img src={Loader} alt="loader" />
//               </div>
//             ) : transactionReport !== undefined ? (
//               <BarChart
//                 width={barChartStyling}
//                 height={250}
//                 margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//                 data={transactionReport}
//               >
//                 <XAxis dataKey="month" />
//                 <YAxis />
//                 <Tooltip />


//                 <Bar dataKey="amount" fill="#003B65" />
//               </BarChart>
//             ) : (
//               <div className={styles.nodataContainer}>
//                 <h1>No Data</h1>
//               </div>
//             )}
//           </div> */}
//           <div className={styles.barChartContainer}>
//             <div className={styles.barChartTopContainer}>
//               <div className={styles.barChartTop}>
//                 <h4>Points Accumulation Report</h4>
//                 <p>View all points earned by customers</p>
//               </div>
//               <Dropdown
//                 data={DropdownYear}
//                 rangeValue={pointAccumulationReportYear}
//                 setRangeValue={setPointAccumulationReportYear}
//               />
//             </div>
//             {/* {!isLoading && (
//             <div className={styles.errorMessageStyling}>{reportError}</div>
//           )} */}
//             {isLoadingPointAccumulation ? (
//               <div className={styles.loaderContainer}>
//                 <img src={Loader} alt="loader" />
//               </div>
//             ) : pointAccumulationReport !== undefined ? (
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart
//                   // width={500}
//                   // height={250}
//                   margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//                   data={pointAccumulationReport}
//                 >
//                   <XAxis dataKey="month" />
//                   <YAxis />
//                   <Tooltip />

//                   {/* <Legend /> */}
//                   <Bar dataKey="Point" name="Count" fill="#FFC400" />
//                 </BarChart>
//               </ResponsiveContainer>
//             ) : (
//               <div className={styles.nodataContainer}>
//                 <h1>No Data</h1>
//               </div>
//             )}
//           </div>
//           <div className={styles.pieChartContainer}>
//             <div className={styles.pieContainer}>
//               <div>
//                 <div className={styles.barChartTop}>
//                   <h4>Channel Usage Summary</h4>
//                   <p>View transaction amount and count for each channel</p>
//                 </div>
//                 <div className={styles.dropdownContainer}>
//                   <Dropdown
//                     data={DropdownYear}
//                     rangeValue={channelUssageYear}
//                     setRangeValue={setChannelUssageYear}

//                   />
//                   <Dropdown
//                     data={monthData}
//                     rangeValue={channelUssageMonth}
//                     setRangeValue={setChannelUssageMonth}
//                   />
//                 </div>
//               </div>

//               {isLoadingChannelData ? (
//                 <div className={styles.loaderContainer}>
//                   <img src={Loader} alt="loader" />
//                 </div>
//               ) : channelUssageData?.amount ? (
//                 <Chart
//                   chartType="PieChart"
//                   width="100%"
//                   height="300px"
//                   data={channelUssageData?.amount}
//                   options={options}
//                 />
//               ) : (
//                 <div className={styles.nodataContainer}>
//                   <h1>No Data</h1>
//                 </div>
//               )}
//               <div className={styles.usageCountContainer}>
//                 <h5 className={styles.usuageCountText}>Usage Count</h5>
//                 <div className={styles.usageCountInnerContainer}>
//                   {channelUssageData?.usage_count?.map((channel, index) => (
//                     <div className={`${styles[`usuageCount${index + 1}`]}`} key={index}>
//                       <h5 className={styles.usuageTitle}>
//                         {channel?.channel_name}
//                       </h5>
//                       <p className={styles.usuageNumber}>
//                         {channel?.usage_count
//                           ? parseInt(
//                               channel?.usage_count,
//                               10
//                             )?.toLocaleString()
//                           : "0"}
//                       </p>
//                     </div>
//                   ))}

//                 </div>
//               </div>
//             </div>
//             <div className={styles.pieContainer}>
//               <div>
//                 <div className={styles.barChartTop}>
//                   <h4>Redemption Chart</h4>
//                   <p>View all redemption chart here</p>
//                 </div>
//                 <div className={styles.dropdownContainer}>
//                   <Dropdown
//                     data={DropdownYear}
//                     rangeValue={redemptionYear}
//                     setRangeValue={setRedemptionYear}
//                   />
//                   <Dropdown
//                     data={monthData}
//                     rangeValue={redemptionMonth}
//                     setRangeValue={setRedemptionMonth}
//                   />
//                 </div>
//                 {/* <div className={styles.dateContainer}>
//                 <div className={styles.innerDateContainer}>
//                   <label htmlFor="">From</label>
//                   <input type="date" name="From" id="" />
//                 </div>
//                 <div className={styles.innerDateContainer}>
//                   <label htmlFor="">To</label>
//                   <input type="date" name="From" id="" />
//                 </div>
//               </div> */}
//               </div>

//               {isLoadingRedemption ? (
//                 <div className={styles.loaderContainer}>
//                   <img src={Loader} alt="loader" />
//                 </div>
//               ) : redemptionData?.amount ? (
//                 <Chart
//                   chartType="PieChart"
//                   width="100%"
//                   height="300px"
//                   data={redemptionData?.amount}
//                   options={RedemptionOptions}
//                 />
//               ) : (
//                 <div className={styles.nodataContainer}>
//                   <h1>No Data</h1>
//                 </div>
//               )}
//               {/* <div className={styles.usageCountContainer}>
//               <h5 className={styles.usuageCountText}>Usage Count</h5>
//               <div className={styles.usageCountInnerContainer}>
//                 <div className={styles.usuageCount1Redemp}>
//                   <h5 className={styles.usuageTitle}>Merchandize</h5>
//                   <p className={styles.usuageNumber}>
//                     {redemptionData?.usage_count?.[0]
//                       ? parseInt(
//                           redemptionData?.usage_count?.[0],
//                           10,
//                         )?.toLocaleString()
//                       : '0'}
//                   </p>
//                 </div>
//                 <div className={styles.usuageCount2Redemp}>
//                   <h5 className={styles.usuageTitle}>Airtime & Bills</h5>
//                   <p className={styles.usuageNumber}>
//                     {redemptionData?.usage_count?.[1]
//                       ? parseInt(
//                           redemptionData?.usage_count?.[1],
//                           10,
//                         )?.toLocaleString()
//                       : '0'}
//                   </p>
//                 </div>
//                 <div className={styles.usuageCount3Redemp}>
//                   <h5 className={styles.usuageTitle}>Meals</h5>
//                   <p className={styles.usuageNumber}>
//                     {redemptionData?.usage_count?.[2]
//                       ? parseInt(
//                           redemptionData?.usage_count?.[2],
//                           10,
//                         )?.toLocaleString()
//                       : '0'}
//                   </p>
//                 </div>
//                 <div className={styles.usuageCount4Redemp}>
//                   <h5 className={styles.usuageTitle}>Entertainment</h5>
//                   <p className={styles.usuageNumber}>
//                     {redemptionData?.usage_count?.[3]
//                       ? parseInt(
//                           redemptionData?.usage_count?.[3],
//                           10,
//                         )?.toLocaleString()
//                       : '0'}
//                   </p>
//                 </div>
//                 <div className={styles.usuageCount5Redemp}>
//                   <h5 className={styles.usuageTitle}>Vouchers</h5>
//                   <p className={styles.usuageNumber}>
//                     {redemptionData?.usage_count?.[4]
//                       ? parseInt(
//                           redemptionData?.usage_count?.[4],
//                           10,
//                         )?.toLocaleString()
//                       : '0'}
//                   </p>
//                 </div>
//               </div>
//             </div> */}
//             </div>
//           </div>
//           <div className={styles.barChartContainer}>
//             <div className={styles.barChartTopContainer}>
//               <div className={styles.barChartTop}>
//                 <h4>Enrollment Report</h4>
//                 <p>This a graph that shows all the enrollment done</p>
//               </div>
//               <Dropdown
//                 data={DropdownYear}
//                 rangeValue={enrolmentReportYear}
//                 setRangeValue={setEnrolmentReportYear}
//               />
//             </div>

//             {isLoadingEnrolment ? (
//               <div className={styles.loaderContainer}>
//                 <img src={Loader} alt="loader" />
//               </div>
//             ) : (
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart
//                   width={barChartStyling}
//                   margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//                   height={250}
//                   data={enrolmentReport}
//                 >
//                   <XAxis dataKey="month" />
//                   <YAxis />
//                   <Tooltip />

//                   <Bar dataKey="Point" name="Count" fill="#003B65" />
//                 </BarChart>
//               </ResponsiveContainer>
//             )}
//           </div>
//           <div className={styles.pieChartContainer}>
//             {/* ======i commented this out ===== */}
//             {/* <div className={styles.pieContainerForfieture}>
//               <div>
//                 <div className={styles.barChartTop}>
//                   <h4>Expired & Forfeited Points Chart</h4>
//                   <p>View Expired & Forfeited Points Chart here</p>
//                 </div>
//                 <div className={styles.dropdownContainer}>
//                   <Dropdown
//                     data={DropdownYear}
//                     rangeValue={expiredPointYear}
//                     setRangeValue={setExpiredPointYear}
//                   />
//                   <Dropdown
//                     data={monthData}
//                     rangeValue={expiredPointMonth}
//                     setRangeValue={setExpiredPointMonth}
//                   />
//                 </div>
//               </div>

//               {isLoadingExpiredPoint ? (
//                 <div className={styles.loaderContainer}>
//                   <img src={Loader} alt="loader" />
//                 </div>
//               ) : expiredPointData ? (
//                 <Chart
//                   chartType="PieChart"
//                   width="100%"
//                   height="300px"
//                   data={expiredPointData}
//                   options={expiredPointOption}
//                 />
//               ) : (
//                 <div className={styles.nodataContainer}>
//                   <h1>No Data</h1>
//                 </div>
//               )}
//             </div> */}

//             {/* ======i ended here ===== */}

//             {/* <div className={styles.pieContainer}>
//             <div>
//               <div className={styles.barChartTop}>
//                 <h4>Customer Delivery Chart</h4>
//                 <p>This is a summary of all the delivery status</p>
//               </div>
//               <div className={styles.dropdownContainer}>
//                 <Dropdown
//                   data={DropdownYear}
//                   rangeValue={customerDeliveryYear}
//                   setRangeValue={setCustomerDeliveryYear}
//                 />
//                 <Dropdown
//                   data={monthData}
//                   rangeValue={customerDeliveryMonth}
//                   setRangeValue={setCustomerDeliveryMonth}
//                 />
//               </div>
//             </div>

//             {customerDeliveryLoading ? (
//               <div className={styles.loaderContainer}>
//                 <img src={Loader} alt="loader" />
//               </div>
//             ) : customerDeliveryData ? (
//               <Chart
//                 chartType="PieChart"
//                 width="100%"
//                 height="300px"
//                 data={customerDeliveryData}
//                 options={customerDeliveryOption}
//               />
//             ) : (
//               <div className={styles.nodataContainer}>
//                 <h1>No Data</h1>
//               </div>
//             )}
//           </div> */}
//           </div>
//         </div>
//   )
//   // return (
//   //   <>
//   //     {activeReport === 0 || !ReportComponent ? (
//   //       <div>
//   //         <div className={styles.topCard}>
//   //           <div className={styles.leftCardContainer}>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Customer Activity Summary</h4>
//   //               <p>View all customer activity on the platform</p>
//   //             </div>
//   //             <div className={styles.cardContainer}>
//   //               <div className={styles.CASCard1}>
//   //                 <p>Logged In Customers</p>
//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(
//   //                       customerActivityData?.loggedin_count
//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //               <div className={styles.CASCard2}>
//   //                 <p>Customers not logged In</p>
//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(
//   //                       customerActivityData?.loggedout_count
//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //               <div className={styles.CASCard3}>
//   //                 <p>Customers who redeemed</p>
//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(
//   //                       customerActivityData?.redeemed_count
//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //               <div className={styles.CASCard4}>
//   //                 <p>Customers yet to redeem</p>
//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(
//   //                       customerActivityData?.not_redeemed_count
//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //             </div>
//   //           </div>
//   //           <div className={styles.rightCardContainer}>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Points Summary</h4>
//   //               <p>View total point summary</p>
//   //             </div>
//   //             <div className={styles.cardContainer}>
//   //               <div className={styles.CASCard5}>
//   //                 <p>Total Points Earned</p>
//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(
//   //                      customerActivityData?.total_gained_points
//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //               <div className={styles.CASCard6}>

//   //                 <p>Total points Redeemed</p>

//   //                 <h4>
//   //                   {isLoadingCustomerActivity ? (
//   //                     <LoadingIcon />
//   //                   ) : (
//   //                     parseInt(


//   //                         customerActivityData?.total_points_issued

//   //                     ).toLocaleString()
//   //                   )}
//   //                 </h4>
//   //               </div>
//   //             </div>
//   //           </div>
//   //         </div>
//   //         {/* <div className={styles.barChartContainer}>
//   //           <div className={styles.barChartTopContainer}>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Incremental Income Report</h4>
//   //               <p>View all transaction amount made by customer</p>
//   //             </div>
//   //             <div className={styles.incrementalReportContainer}>
//   //               <Link
//   //                 target="_blank"
//   //                 to="https://greenrewards.perxclm.com/monthly_transaction_report.php"
//   //               >
//   //                 <button className={styles.incrementalBTN}>
//   //                   <DonwloadIcon /> Download Data
//   //                 </button>
//   //               </Link>

//   //               <Dropdown
//   //                 data={DropdownYear}
//   //                 rangeValue={dataYear}
//   //                 setRangeValue={setDataYear}
//   //               />
//   //             </div>
//   //           </div>
//   //           {!isLoading && (
//   //           <div className={styles.errorMessageStyling}>{reportError}</div>
//   //         )}
//   //           {isLoading ? (
//   //             <div className={styles.loaderContainer}>
//   //               <img src={Loader} alt="loader" />
//   //             </div>
//   //           ) : transactionReport !== undefined ? (
//   //             <BarChart
//   //               width={barChartStyling}
//   //               height={250}
//   //               margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//   //               data={transactionReport}
//   //             >
//   //               <XAxis dataKey="month" />
//   //               <YAxis />
//   //               <Tooltip />


//   //               <Bar dataKey="amount" fill="#003B65" />
//   //             </BarChart>
//   //           ) : (
//   //             <div className={styles.nodataContainer}>
//   //               <h1>No Data</h1>
//   //             </div>
//   //           )}
//   //         </div> */}
//   //         <div className={styles.barChartContainer}>
//   //           <div className={styles.barChartTopContainer}>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Points Accumulation Report</h4>
//   //               <p>View all points earned by customers</p>
//   //             </div>
//   //             <Dropdown
//   //               data={DropdownYear}
//   //               rangeValue={pointAccumulationReportYear}
//   //               setRangeValue={setPointAccumulationReportYear}
//   //             />
//   //           </div>
//   //           {/* {!isLoading && (
//   //           <div className={styles.errorMessageStyling}>{reportError}</div>
//   //         )} */}
//   //           {isLoadingPointAccumulation ? (
//   //             <div className={styles.loaderContainer}>
//   //               <img src={Loader} alt="loader" />
//   //             </div>
//   //           ) : pointAccumulationReport !== undefined ? (
//   //             <ResponsiveContainer width="100%" height={300}>
//   //               <BarChart
//   //                 // width={500}
//   //                 // height={250}
//   //                 margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//   //                 data={pointAccumulationReport}
//   //               >
//   //                 <XAxis dataKey="month" />
//   //                 <YAxis />
//   //                 <Tooltip />

//   //                 {/* <Legend /> */}
//   //                 <Bar dataKey="Point" name="Count" fill="#FFC400" />
//   //               </BarChart>
//   //             </ResponsiveContainer>
//   //           ) : (
//   //             <div className={styles.nodataContainer}>
//   //               <h1>No Data</h1>
//   //             </div>
//   //           )}
//   //         </div>
//   //         <div className={styles.pieChartContainer}>
//   //           <div className={styles.pieContainer}>
//   //             <div>
//   //               <div className={styles.barChartTop}>
//   //                 <h4>Channel Usage Summary</h4>
//   //                 <p>View transaction amount and count for each channel</p>
//   //               </div>
//   //               <div className={styles.dropdownContainer}>
//   //                 <Dropdown
//   //                   data={DropdownYear}
//   //                   rangeValue={channelUssageYear}
//   //                   setRangeValue={setChannelUssageYear}
//   //                 />
//   //                 <Dropdown
//   //                   data={monthData}
//   //                   rangeValue={channelUssageMonth}
//   //                   setRangeValue={setChannelUssageMonth}
//   //                 />
//   //               </div>
//   //             </div>

//   //             {isLoadingChannelData ? (
//   //               <div className={styles.loaderContainer}>
//   //                 <img src={Loader} alt="loader" />
//   //               </div>
//   //             ) : channelUssageData?.amount ? (
//   //               <Chart
//   //                 chartType="PieChart"
//   //                 width="100%"
//   //                 height="300px"
//   //                 data={channelUssageData?.amount}
//   //                 options={options}
//   //               />
//   //             ) : (
//   //               <div className={styles.nodataContainer}>
//   //                 <h1>No Data</h1>
//   //               </div>
//   //             )}
//   //             <div className={styles.usageCountContainer}>
//   //               <h5 className={styles.usuageCountText}>Usage Count</h5>
//   //               <div className={styles.usageCountInnerContainer}>
//   //                 {channelUssageData?.usage_count?.map((channel, index) => (
//   //                   <div className={`${styles[`usuageCount${index + 1}`]}`} key={index}>
//   //                     <h5 className={styles.usuageTitle}>
//   //                       {channel?.channel_name}
//   //                     </h5>
//   //                     <p className={styles.usuageNumber}>
//   //                       {channel?.usage_count
//   //                         ? parseInt(
//   //                             channel?.usage_count,
//   //                             10
//   //                           )?.toLocaleString()
//   //                         : "0"}
//   //                     </p>
//   //                   </div>
//   //                 ))}

//   //               </div>
//   //             </div>
//   //           </div>
//   //           <div className={styles.pieContainer}>
//   //             <div>
//   //               <div className={styles.barChartTop}>
//   //                 <h4>Redemption Chart</h4>
//   //                 <p>View all redemption chart here</p>
//   //               </div>
//   //               <div className={styles.dropdownContainer}>
//   //                 <Dropdown
//   //                   data={DropdownYear}
//   //                   rangeValue={redemptionYear}
//   //                   setRangeValue={setRedemptionYear}
//   //                 />
//   //                 <Dropdown
//   //                   data={monthData}
//   //                   rangeValue={redemptionMonth}
//   //                   setRangeValue={setRedemptionMonth}
//   //                 />
//   //               </div>
//   //               {/* <div className={styles.dateContainer}>
//   //               <div className={styles.innerDateContainer}>
//   //                 <label htmlFor="">From</label>
//   //                 <input type="date" name="From" id="" />
//   //               </div>
//   //               <div className={styles.innerDateContainer}>
//   //                 <label htmlFor="">To</label>
//   //                 <input type="date" name="From" id="" />
//   //               </div>
//   //             </div> */}
//   //             </div>

//   //             {isLoadingRedemption ? (
//   //               <div className={styles.loaderContainer}>
//   //                 <img src={Loader} alt="loader" />
//   //               </div>
//   //             ) : redemptionData?.amount ? (
//   //               <Chart
//   //                 chartType="PieChart"
//   //                 width="100%"
//   //                 height="300px"
//   //                 data={redemptionData?.amount}
//   //                 options={RedemptionOptions}
//   //               />
//   //             ) : (
//   //               <div className={styles.nodataContainer}>
//   //                 <h1>No Data</h1>
//   //               </div>
//   //             )}
//   //             {/* <div className={styles.usageCountContainer}>
//   //             <h5 className={styles.usuageCountText}>Usage Count</h5>
//   //             <div className={styles.usageCountInnerContainer}>
//   //               <div className={styles.usuageCount1Redemp}>
//   //                 <h5 className={styles.usuageTitle}>Merchandize</h5>
//   //                 <p className={styles.usuageNumber}>
//   //                   {redemptionData?.usage_count?.[0]
//   //                     ? parseInt(
//   //                         redemptionData?.usage_count?.[0],
//   //                         10,
//   //                       )?.toLocaleString()
//   //                     : '0'}
//   //                 </p>
//   //               </div>
//   //               <div className={styles.usuageCount2Redemp}>
//   //                 <h5 className={styles.usuageTitle}>Airtime & Bills</h5>
//   //                 <p className={styles.usuageNumber}>
//   //                   {redemptionData?.usage_count?.[1]
//   //                     ? parseInt(
//   //                         redemptionData?.usage_count?.[1],
//   //                         10,
//   //                       )?.toLocaleString()
//   //                     : '0'}
//   //                 </p>
//   //               </div>
//   //               <div className={styles.usuageCount3Redemp}>
//   //                 <h5 className={styles.usuageTitle}>Meals</h5>
//   //                 <p className={styles.usuageNumber}>
//   //                   {redemptionData?.usage_count?.[2]
//   //                     ? parseInt(
//   //                         redemptionData?.usage_count?.[2],
//   //                         10,
//   //                       )?.toLocaleString()
//   //                     : '0'}
//   //                 </p>
//   //               </div>
//   //               <div className={styles.usuageCount4Redemp}>
//   //                 <h5 className={styles.usuageTitle}>Entertainment</h5>
//   //                 <p className={styles.usuageNumber}>
//   //                   {redemptionData?.usage_count?.[3]
//   //                     ? parseInt(
//   //                         redemptionData?.usage_count?.[3],
//   //                         10,
//   //                       )?.toLocaleString()
//   //                     : '0'}
//   //                 </p>
//   //               </div>
//   //               <div className={styles.usuageCount5Redemp}>
//   //                 <h5 className={styles.usuageTitle}>Vouchers</h5>
//   //                 <p className={styles.usuageNumber}>
//   //                   {redemptionData?.usage_count?.[4]
//   //                     ? parseInt(
//   //                         redemptionData?.usage_count?.[4],
//   //                         10,
//   //                       )?.toLocaleString()
//   //                     : '0'}
//   //                 </p>
//   //               </div>
//   //             </div>
//   //           </div> */}
//   //           </div>
//   //         </div>
//   //         <div className={styles.barChartContainer}>
//   //           <div className={styles.barChartTopContainer}>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Enrollment Report</h4>
//   //               <p>This a graph that shows all the enrollment done</p>
//   //             </div>
//   //             <Dropdown
//   //               data={DropdownYear}
//   //               rangeValue={enrolmentReportYear}
//   //               setRangeValue={setEnrolmentReportYear}
//   //             />
//   //           </div>

//   //           {isLoadingEnrolment ? (
//   //             <div className={styles.loaderContainer}>
//   //               <img src={Loader} alt="loader" />
//   //             </div>
//   //           ) : (
//   //             <ResponsiveContainer width="100%" height={300}>
//   //               <BarChart
//   //                 width={barChartStyling}
//   //                 margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
//   //                 height={250}
//   //                 data={enrolmentReport}
//   //               >
//   //                 <XAxis dataKey="month" />
//   //                 <YAxis />
//   //                 <Tooltip />

//   //                 <Bar dataKey="Point" name="Count" fill="#003B65" />
//   //               </BarChart>
//   //             </ResponsiveContainer>
//   //           )}
//   //         </div>
//   //         <div className={styles.pieChartContainer}>
//   //           {/* ======i commented this out ===== */}
//   //           {/* <div className={styles.pieContainerForfieture}>
//   //             <div>
//   //               <div className={styles.barChartTop}>
//   //                 <h4>Expired & Forfeited Points Chart</h4>
//   //                 <p>View Expired & Forfeited Points Chart here</p>
//   //               </div>
//   //               <div className={styles.dropdownContainer}>
//   //                 <Dropdown
//   //                   data={DropdownYear}
//   //                   rangeValue={expiredPointYear}
//   //                   setRangeValue={setExpiredPointYear}
//   //                 />
//   //                 <Dropdown
//   //                   data={monthData}
//   //                   rangeValue={expiredPointMonth}
//   //                   setRangeValue={setExpiredPointMonth}
//   //                 />
//   //               </div>
//   //             </div>

//   //             {isLoadingExpiredPoint ? (
//   //               <div className={styles.loaderContainer}>
//   //                 <img src={Loader} alt="loader" />
//   //               </div>
//   //             ) : expiredPointData ? (
//   //               <Chart
//   //                 chartType="PieChart"
//   //                 width="100%"
//   //                 height="300px"
//   //                 data={expiredPointData}
//   //                 options={expiredPointOption}
//   //               />
//   //             ) : (
//   //               <div className={styles.nodataContainer}>
//   //                 <h1>No Data</h1>
//   //               </div>
//   //             )}
//   //           </div> */}

//   //           {/* ======i ended here ===== */}

//   //           {/* <div className={styles.pieContainer}>
//   //           <div>
//   //             <div className={styles.barChartTop}>
//   //               <h4>Customer Delivery Chart</h4>
//   //               <p>This is a summary of all the delivery status</p>
//   //             </div>
//   //             <div className={styles.dropdownContainer}>
//   //               <Dropdown
//   //                 data={DropdownYear}
//   //                 rangeValue={customerDeliveryYear}
//   //                 setRangeValue={setCustomerDeliveryYear}
//   //               />
//   //               <Dropdown
//   //                 data={monthData}
//   //                 rangeValue={customerDeliveryMonth}
//   //                 setRangeValue={setCustomerDeliveryMonth}
//   //               />
//   //             </div>
//   //           </div>

//   //           {customerDeliveryLoading ? (
//   //             <div className={styles.loaderContainer}>
//   //               <img src={Loader} alt="loader" />
//   //             </div>
//   //           ) : customerDeliveryData ? (
//   //             <Chart
//   //               chartType="PieChart"
//   //               width="100%"
//   //               height="300px"
//   //               data={customerDeliveryData}
//   //               options={customerDeliveryOption}
//   //             />
//   //           ) : (
//   //             <div className={styles.nodataContainer}>
//   //               <h1>No Data</h1>
//   //             </div>
//   //           )}
//   //         </div> */}
//   //         </div>
//   //       </div>



//   //     ) : (
//   //       <ReportComponent />
//   //     )}
//   //   </>
//   // );
// };

// export default Dashboard;


import React from "react";

import FBNStructure from "../FBNStructure/FBNStructure";
import styles from "../../styles/Dashboard.module.scss";
import { reportScreensMap } from "../../components/ReportScreens/ReportScreens";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  // CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useState } from "react";
import { useEffect } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";
import Chart from "react-google-charts";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Loader from "../../assets/images/fidelityLoader.gif";
import { DonwloadIcon, LoadingIcon } from "../../assets/icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const API_ENDPOINT =
  "https://firstbankapi-dpf7ajceb9czfbe2.francecentral-01.azurewebsites.net/api/api";
let customerActivityCurrentPreviousMonth;

const Dashboard = () => {
  // const activeReport = useSelector(
  //   (state) => state?.dashboardActivePage?.activeReport
  // );

  const currentYear = new Date().getFullYear();
  const DropdownYear = [{ value: 2025 }, { value: 2026 }];

  const [barChartStyling, setBarChartStyling] = useState(1000);

  useEffect(() => {
    const handleResize = () => {
      const value = window.innerWidth;
      if (value > 888) {
        setBarChartStyling(value - 300);
      } else {
        setBarChartStyling(value - 50);
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const monthData = [
    { value: "Jan", monthNumber: "01" },
    { value: "Feb", monthNumber: "02" },
    { value: "Mar", monthNumber: "03" },
    { value: "Apr", monthNumber: "04" },
    { value: "May", monthNumber: "05" },
    { value: "Jun", monthNumber: "06" },
    { value: "Jul", monthNumber: "07" },
    { value: "Aug", monthNumber: "08" },
    { value: "Sep", monthNumber: "09" },
    { value: "Oct", monthNumber: "10" },
    { value: "Nov", monthNumber: "11" },
    { value: "Dec", monthNumber: "12" },
  ];

  /////////CUSTOMER ACTIVITIES START////////////
  const fetchCustomerActivity = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_FIRSTBANK_BASEURL}/customer_activity`,
        {
          headers: {
            "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
          },
        }
      );

      return response?.data?.success;
    } catch (error) {
      throw error;
    }
  };

  const {
    data: customerActivityData,
    isLoading: isLoadingCustomerActivity,
    refetch: refetchCustomerActivity,
  } = useQuery({
    queryKey: ["customer-activity-summary"],
    queryFn: () => fetchCustomerActivity(),
  });
  ////////////// API CALL FOR Transaction Report/////////////////////////
  const [dataYear, setDataYear] = useState(currentYear);

  const [reportError, setReportError] = useState("");
  const fetchData = async (year = "") => {
    const params = {
      year: year || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/transaction_amount`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    if (response?.data?.status === 0) {
      setReportError(response?.data?.message);
    }

    return response?.data;
  };

  const {
    data: transactionReport,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["transactionData", dataYear],
    queryFn: () => fetchData(dataYear),
    enabled: !!dataYear,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    refetch();
  }, [dataYear]);

  ////////////Transaction Report End ////////////

  /////////////////////// EMAIL DURABILITY (AGGREGATE EMAIL HISTORY) ///////////////////////
  const fetchAggregateEmailsHistory = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/aggregate_emails_history`,
      {
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );
    return response?.data?.data;
  };

  const {
    data: emailDurabilityData,
    isLoading: isLoadingEmailDurability,
    isError: isErrorEmailDurability,
  } = useQuery({
    queryKey: ["aggregate-emails-history"],
    queryFn: fetchAggregateEmailsHistory,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  /////////////////////////////////// Point Accumulation Report/////////////////////////////////////
  const [pointAccumulationReportYear, setPointAccumulationReportYear] = useState(currentYear);

  const fetchPointAccumulationReportData = async (year = "") => {
    const params = {
      year: year || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/points_accumulation`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    return response?.data;
  };

  const {
    data: pointAccumulationReport,
    isLoading: isLoadingPointAccumulation,
    isError: isErrorPointAccumulation,
    refetch: refetchPointAccumulation,
  } = useQuery({
    queryKey: ["point-accumulation-data", pointAccumulationReportYear],
    queryFn: () =>
      fetchPointAccumulationReportData(pointAccumulationReportYear),
    enabled: !!pointAccumulationReportYear,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    refetchPointAccumulation();
  }, [pointAccumulationReportYear]);

  /////////POINT ACCUMULATION REPORT END ///////////

  ////////////// STATUS CARDS //////////////
  const fetchPointToCashStatus = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_point_to_cash_status`,
      { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
    );
    return response?.data;
  };

  const fetchBapRedemptionStatus = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_bap_redemption_status`,
      { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
    );
    return response?.data;
  };

  const fetchAcquisitionStatus = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_acquisition_processing_status`,
      { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
    );
    return response?.data;
  };

  const fetchEmailProcessingStatus = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/check_email_processing_status`,
      { headers: { "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN } }
    );
    return response?.data;
  };

  const { data: pointToCashStatus, isLoading: isLoadingPointToCash } = useQuery({
    queryKey: ["pointToCashStatus"],
    queryFn: fetchPointToCashStatus,
  });

  const { data: bapRedemptionStatus, isLoading: isLoadingBapRedemption } = useQuery({
    queryKey: ["bapRedemptionStatus"],
    queryFn: fetchBapRedemptionStatus,
  });

  const { data: acquisitionStatus, isLoading: isLoadingAcquisition } = useQuery({
    queryKey: ["acquisitionStatus"],
    queryFn: fetchAcquisitionStatus,
  });

  const { data: emailProcessingStatus, isLoading: isLoadingEmailProcessing } = useQuery({
    queryKey: ["emailProcessingStatus"],
    queryFn: fetchEmailProcessingStatus,
  });
  ////////////// STATUS CARDS END //////////////

  /////////////////////// Channel Usage Summary (Pie Chart)//////////////////////////////

  const options = {
    pieHole: 0.5,
    is3D: false,
    colors: ["#0E237D", "#0D99FF", "#4FC143", "#27824D", "#989898"],
  };

  const [channelUssageYear, setChannelUssageYear] = useState(currentYear);
  const [channelUssageError, setChannelUssageError] = useState("");

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  let previousMonth;

  if (currentMonth === 0) {
    previousMonth = 11;
  } else {
    previousMonth = currentMonth;
  }

  const [channelUssageMonthNumber, setChannelUssageMonthNumber] =
    useState(previousMonth);

  const currentMonthName = monthData[channelUssageMonthNumber];

  const [channelUssageMonth, setChannelUssageMonth] = useState(
    currentMonthName?.value
  );

  const queryMonth = monthData.filter(
    (each) => each.value === channelUssageMonth
  );

  const fetchChannelUssageData = async (year = "", month = "") => {
    const params = {
      year: year || undefined,
      month: month || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/channel_summary`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    if (response.data.status === 0) {
      setChannelUssageError(response?.data.message);
    }

    return response?.data?.output;
  };

  // ////////////////////////// Redemption Chart ///////////////////////////
  const RedemptionOptions = {
    tooltip: { trigger: "none" },
    pieHole: 0.5,
    is3D: false,
    colors: ["#FF6B6A", "#FFCD29", "#7B61FF", "#E1E7FF", "#0D99FF"],
  };

  const [redemptionYear, setRedemptionYear] = useState(currentYear);

  const redemptionDate = new Date();
  const redemptionCurrentMonth = redemptionDate.getMonth();
  let redemptionPreviousMonth;

  if (redemptionCurrentMonth === 0) {
    redemptionPreviousMonth = 11;
  } else {
    redemptionPreviousMonth = redemptionCurrentMonth;
  }

  const [redemptionMonthNumber, setRedemptionMonthNumber] = useState(
    redemptionPreviousMonth
  );

  const redemptionMonthName = monthData[redemptionMonthNumber];

  const [redemptionMonth, setRedemptionMonth] = useState(
    redemptionMonthName?.value
  );

  const redemptionQueryMonth = monthData.filter(
    (each) => each.value === redemptionMonth
  );

  const fetchRedemptionData = async (year = "", month = "") => {
    const params = {
      year: year || undefined,
      month: month || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/redemption_report`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    return response?.data?.output;
  };

  const {
    data: channelUssageData,
    isPending: isLoadingChannelData,
    isError: isErrorChannelData,
    refetch: refetchChannelData,
  } = useQuery({
    queryKey: [
      "channelUsageData",
      channelUssageYear,
      queryMonth?.[0]?.monthNumber,
    ],
    queryFn: () =>
      fetchChannelUssageData(channelUssageYear, queryMonth?.[0]?.monthNumber),
    enabled: !!channelUssageYear && !!queryMonth?.[0]?.monthNumber,
  });

  const {
    data: redemptionData,
    isPending: isLoadingRedemption,
    isError: isErrorRedemption,
    refetch: refetchRedemption,
  } = useQuery({
    queryKey: [
      "redemptionData",
      redemptionYear,
      redemptionQueryMonth?.[0]?.monthNumber,
    ],
    queryFn: () =>
      fetchRedemptionData(
        redemptionYear,
        redemptionQueryMonth?.[0]?.monthNumber
      ),
    enabled: !!redemptionYear && !!redemptionQueryMonth?.[0]?.monthNumber,
  });

  /////////////////////////////////// Enrollment Report/////////////////////////////////////
  const [enrolmentReportYear, setEnrolmentReportYear] = useState(currentYear);

  const fetchEnrolmentReportData = async (year = "") => {
    const params = {
      year: year || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/enrollment_data`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    return response?.data;
  };

  const {
    data: enrolmentReport,
    isPending: isLoadingEnrolment,
    isError: isErrorEnrolment,
    refetch: refetchEnrolment,
  } = useQuery({
    queryKey: ["enrolmentData", enrolmentReportYear],
    queryFn: () => fetchEnrolmentReportData(enrolmentReportYear),
    enabled: !!enrolmentReportYear,
  });

  useEffect(() => {
    refetchEnrolment();
  }, [enrolmentReportYear]);

  /////////////// Expired & Forfeited Points Chart //////////////////////////////
  const expiredPointOption = {
    pieHole: 0.5,
    is3D: false,
    colors: ["#747272", "#0D99FF"],
  };

  const [expiredPointYear, setExpiredPointYear] = useState(currentYear);

  const expiredPointCurrentDate = new Date();
  const expiredPointCurrentMonth = expiredPointCurrentDate.getMonth();
  let expiredPointCurrentPreviousMonth;

  if (expiredPointCurrentMonth === 0) {
    expiredPointCurrentPreviousMonth = 11;
  } else {
    expiredPointCurrentPreviousMonth = expiredPointCurrentMonth - 1;
  }

  const [expiredPointMonthNumber, setExpiredPointMonthNumber] = useState(
    expiredPointCurrentPreviousMonth
  );

  const expiredPointMonthName = monthData[expiredPointMonthNumber];

  const [expiredPointMonth, setExpiredPointMonth] = useState(
    expiredPointMonthName?.value
  );

  const expiredPointQueryMonth = monthData.filter(
    (each) => each.value === expiredPointMonth
  );

  const fetchExpiredPointData = async (year = "", month = "") => {
    const params = {
      year: year || undefined,
      month: month || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/point_report`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    return response?.data?.output;
  };

  const {
    data: expiredPointData,
    isPending: isLoadingExpiredPoint,
    isError: isErrorExpiredPoint,
    refetch: refetchExpiredPoint,
  } = useQuery({
    queryKey: [
      "expiredPointData",
      expiredPointYear,
      expiredPointQueryMonth?.[0]?.monthNumber,
    ],
    queryFn: () =>
      fetchExpiredPointData(
        expiredPointYear,
        expiredPointQueryMonth?.[0]?.monthNumber
      ),
    enabled: !!expiredPointYear && !!expiredPointQueryMonth?.[0]?.monthNumber,
  });

  const [customerActivityYear, setCustomerActivityYear] = useState(currentYear);

  const customerActivityCurrentDate = new Date();
  const customerActivityCurrentMonth = customerActivityCurrentDate.getMonth();

  if (customerActivityCurrentMonth === 0) {
    customerActivityCurrentPreviousMonth = 11;
  } else {
    customerActivityCurrentPreviousMonth = customerActivityCurrentMonth - 1;
  }

  const [customerActivityMonthNumber, setCustomerActivityMonthNumber] =
    useState(customerActivityCurrentPreviousMonth);

  const customerActivityMonthName = monthData[customerActivityMonthNumber];

  const [customerActivityMonth, setCustomerActivityMonth] = useState(
    customerActivityMonthName?.value
  );

  const customerActivityQueryMonth = monthData.filter(
    (each) => each.value === customerActivityMonth
  );

  ///////////////////// Customer Delivery Chart////////////////////////////////
  const customerDeliveryOption = {
    pieHole: 0.5,
    is3D: false,
    colors: ["#4FC143", "#FF005F"],
  };

  const [customerDeliveryYear, setCustomerDeliveryYear] = useState(currentYear);

  const customerDeliveryDate = new Date();
  const customerDeliveryCurrentMonth = customerDeliveryDate.getMonth();
  let customerDeliveryPreviousMonth;

  if (customerDeliveryCurrentMonth === 0) {
    customerDeliveryPreviousMonth = 11;
  } else {
    customerDeliveryPreviousMonth = customerDeliveryCurrentMonth - 1;
  }

  const [customerDeliveryMonthNumber, setCustomerDeliveryMonthNumber] =
    useState(customerActivityCurrentPreviousMonth);

  const customerDeliveryMonthName = monthData[customerDeliveryMonthNumber];

  const [customerDeliveryMonth, setCustomerDeliveryMonth] = useState(
    customerDeliveryMonthName?.value
  );

  const customerDeliveryQueryMonth = monthData.filter(
    (each) => each.value === customerDeliveryMonth
  );

  const fetchCustomerDelivery = async (year = "", month = "") => {
    const params = {
      year: year || undefined,
      month: month || undefined,
    };

    const response = await axios.get(
      `${process.env.REACT_APP_FIRSTBANK_BASEURL}/customer_delivery`,
      {
        params,
        headers: {
          "dashboard-key": process.env.REACT_APP_FIRSTBANK_TOKEN,
        },
      }
    );

    return response?.data?.output;
  };

  const {
    data: customerDeliveryData,
    isPending: customerDeliveryLoading,
    isError: customerDeliveryError,
    refetch: refetchCustomerDelivery,
  } = useQuery({
    queryKey: [
      "customerDeliveryData",
      customerDeliveryYear,
      customerDeliveryQueryMonth?.[0]?.monthNumber,
    ],
    queryFn: () =>
      fetchCustomerDelivery(
        customerDeliveryYear,
        customerDeliveryQueryMonth?.[0]?.monthNumber
      ),
    enabled:
      !!customerDeliveryYear && !!customerDeliveryQueryMonth?.[0]?.monthNumber,
  });

  // Utility function to format a Date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [expectedPointsDate, setExpectedPointsDate] = useState(formatDate(new Date()));

  // Fetch function for total expected points
  const fetchTotalExpectedPoints = async (date) => {
    try {
      const response = await axios.get(
        `https://firstbank-live-perx-instance-f9g2dfakgdgmgaar.francecentral-01.azurewebsites.net/scripts/total_expected_points.php`,
        { params: { date } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const {
    data: expectedPointsData,
    isLoading: isLoadingExpectedPoints,
    refetch: refetchExpectedPoints,
  } = useQuery({
    queryKey: ["total-expected-points", expectedPointsDate],
    queryFn: () => fetchTotalExpectedPoints(expectedPointsDate),
    enabled: !!expectedPointsDate,
  });

  useEffect(() => {
    refetchExpectedPoints();
  }, [expectedPointsDate]);

  return (
    <div>
      {/* TOP CARDS */}
      <div className={styles.topCard}>
        <div className={styles.leftCardContainer}>
          <div className={styles.barChartTop}>
            <div>
              <h4>Customer Activity Summary</h4>
              <p>View all customer activity on the platform</p>
            </div>
          </div>
          <div className={styles.cardContainer}>
            <div className={styles.CASCard1}>
              <p>Logged In Customers</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.loggedin_count
                    ? parseInt(customerActivityData?.loggedin_count).toLocaleString()
                    : 0
                )}
              </h4>
            </div>
            <div className={styles.CASCard2}>
              <p>Customers not logged In</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.loggedout_count
                    ? parseInt(customerActivityData?.loggedout_count).toLocaleString()
                    : 0
                )}
              </h4>
            </div>
            <div className={styles.CASCard3}>
              <p>Customers who redeemed</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.redeemed_count
                    ? parseInt(customerActivityData?.redeemed_count).toLocaleString()
                    : 0
                )}
              </h4>
            </div>
            <div className={styles.CASCard4}>
              <p>Customers yet to redeem</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.not_redeemed_count
                    ? parseInt(customerActivityData?.not_redeemed_count).toLocaleString()
                    : 0
                )}
              </h4>
            </div>
          </div>
        </div>

        <div className={styles.rightCardContainer}>
          <div className={styles.barChartTop}>
            <div>
              <h4>Points Summary</h4>
              <p>View total point summary</p>
            </div>
            <input
              type="date"
              id="expectedPointsDate"
              value={expectedPointsDate}
              onChange={(e) => setExpectedPointsDate(e.target.value)}
              className={styles.dateInput}
            />
          </div>

          <div className={styles.cardContainer}>
            <div className={styles.CASCard5}>
              <p>Total Points Earned</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.total_gained_points
                    ? parseInt(customerActivityData?.total_gained_points).toLocaleString()
                    : 0
                )}
              </h4>
            </div>

            <div className={styles.CASCard6}>
              <p>Total points Redeemed</p>
              <h4>
                {isLoadingCustomerActivity ? (
                  <LoadingIcon />
                ) : (
                  customerActivityData?.total_points_issued
                    ? parseInt(customerActivityData?.total_points_issued).toLocaleString()
                    : 0
                )}
              </h4>
            </div>

            <div className={styles.CASCard7}>
              <p>Total points Expected (Daily)</p>
              <h4>
                {isLoadingExpectedPoints ? (
                  <LoadingIcon />
                ) : (
                  expectedPointsData?.Total_expected_points
                    ? parseInt(expectedPointsData?.Total_expected_points).toLocaleString()
                    : 0
                )}
              </h4>
            </div>

            <div className={styles.CASCard8}>
              <p>Total points Issued (Daily)</p>
              <h4>
                {isLoadingExpectedPoints ? (
                  <LoadingIcon />
                ) : (
                  expectedPointsData?.Total_accumulated_points
                    ? parseInt(expectedPointsData?.Total_accumulated_points).toLocaleString()
                    : 0
                )}
              </h4>
            </div>

            <div className={styles.CASCard9}>
              <p>Total Transactions Dumped (Daily)</p>
              <h4>
                {isLoadingExpectedPoints ? (
                  <LoadingIcon />
                ) : (
                  expectedPointsData?.Total_transaction_dumped
                    ? parseInt(expectedPointsData?.Total_transaction_dumped).toLocaleString()
                    : 0
                )}
              </h4>
            </div>

            <div className={styles.CASCard10}>
              <p>Total Transactions Processed (Daily)</p>
              <h4>
                {isLoadingExpectedPoints ? (
                  <LoadingIcon />
                ) : (
                  expectedPointsData?.Total_processed_transactions
                    ? parseInt(expectedPointsData?.Total_processed_transactions).toLocaleString()
                    : 0
                )}
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* STATUS CARDS */}
      <div className={styles.statusCardsContainer}>
        <div className={styles.barChartTop}>
          <h4>Processing Status</h4>
          <p>Live status of all background processes</p>
        </div>
        <div className={styles.statusCardsInner}>
          <div className={styles.statusCard}>
            <p className={styles.statusCardTitle}>Points to Cash Status</p>
            {isLoadingPointToCash ? (
              <LoadingIcon />
            ) : (
              <span
                className={
                  pointToCashStatus?.toLowerCase() === "active"
                    ? styles.statusBadgeActive
                    : styles.statusBadgeInactive
                }
              >
                {pointToCashStatus ?? "N/A"}
              </span>
            )}
          </div>

          <div className={styles.statusCard}>
            <p className={styles.statusCardTitle}>BAP Redemption Status</p>
            {isLoadingBapRedemption ? (
              <LoadingIcon />
            ) : (
              <span
                className={
                  bapRedemptionStatus?.toLowerCase() === "active"
                    ? styles.statusBadgeActive
                    : styles.statusBadgeInactive
                }
              >
                {bapRedemptionStatus ?? "N/A"}
              </span>
            )}
          </div>

          <div className={styles.statusCard}>
            <p className={styles.statusCardTitle}>Acquisition Processing Status</p>
            {isLoadingAcquisition ? (
              <LoadingIcon />
            ) : (
              <span
                className={
                  acquisitionStatus?.toLowerCase() === "active"
                    ? styles.statusBadgeActive
                    : styles.statusBadgeInactive
                }
              >
                {acquisitionStatus ?? "N/A"}
              </span>
            )}
          </div>

          <div className={styles.statusCard}>
            <p className={styles.statusCardTitle}>Email Processing Status</p>
            {isLoadingEmailProcessing ? (
              <LoadingIcon />
            ) : (
              <span
                className={
                  emailProcessingStatus?.toLowerCase() === "active"
                    ? styles.statusBadgeActive
                    : styles.statusBadgeInactive
                }
              >
                {emailProcessingStatus ?? "N/A"}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* EMAIL DURABILITY REPORT */}
      <div className={styles.barChartContainer}>
        <div className={styles.barChartTopContainer}>
          <div className={styles.barChartTop}>
            <h4>Email Durability</h4>
            <p>View aggregate email history breakdown by day</p>
          </div>
        </div>

        {isLoadingEmailDurability ? (
          <div className={styles.loaderContainer}>
            <img src={Loader} alt="loader" />
          </div>
        ) : emailDurabilityData && emailDurabilityData.length > 0 ? (
          <>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                margin={{ top: 10, right: 10, left: 20, bottom: 5 }}
                data={emailDurabilityData}
              >
                <XAxis dataKey="day" />
                <YAxis />
                {/* shared={false} ensures tooltip only shows the single bar being hovered */}
                <Tooltip shared={false} />
                <Legend />
                <Bar
                  dataKey="total_expected"
                  name="Total Email Count"
                  fill="#FACC15"
                />
                <Bar
                  dataKey="total_sent"
                  name="Email Sent"
                  fill="#22C55E"
                />
                <Bar
                  dataKey="failed"
                  name="Email Failed"
                  fill="#EF4444"
                />
              </BarChart>
            </ResponsiveContainer>

            {/* COLOR GUIDE / LEGEND */}
            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "24px",
                marginTop: "16px",
                paddingTop: "12px",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#FACC15",
                    borderRadius: "3px",
                    display: "inline-block",
                  }}
                ></span>
                <span style={{ fontSize: "13px", color: "#4B5563" }}>
                  Total Email Count
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#22C55E",
                    borderRadius: "3px",
                    display: "inline-block",
                  }}
                ></span>
                <span style={{ fontSize: "13px", color: "#4B5563" }}>
                  Email Sent
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#EF4444",
                    borderRadius: "3px",
                    display: "inline-block",
                  }}
                ></span>
                <span style={{ fontSize: "13px", color: "#4B5563" }}>
                  Email Failed
                </span>
              </div>
            </div> */}
          </>
        ) : (
          <div className={styles.nodataContainer}>
            <h1>No Data</h1>
          </div>
        )}
      </div>

      {/* POINTS ACCUMULATION REPORT */}
      <div className={styles.barChartContainer}>
        <div className={styles.barChartTopContainer}>
          <div className={styles.barChartTop}>
            <h4>Points Accumulation Report</h4>
            <p>View all points earned by customers</p>
          </div>
          <Dropdown
            data={DropdownYear}
            rangeValue={pointAccumulationReportYear}
            setRangeValue={setPointAccumulationReportYear}
          />
        </div>

        {isLoadingPointAccumulation ? (
          <div className={styles.loaderContainer}>
            <img src={Loader} alt="loader" />
          </div>
        ) : pointAccumulationReport !== undefined ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
              data={pointAccumulationReport}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="Point" name="Count" fill="#FFC400" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className={styles.nodataContainer}>
            <h1>No Data</h1>
          </div>
        )}
      </div>

      {/* PIE CHARTS SECTION */}
      <div className={styles.pieChartContainer}>
        <div className={styles.pieContainer}>
          <div>
            <div className={styles.barChartTop}>
              <h4>Channel Usage Summary</h4>
              <p>View transaction amount and count for each channel</p>
            </div>
            <div className={styles.dropdownContainer}>
              <Dropdown
                data={DropdownYear}
                rangeValue={channelUssageYear}
                setRangeValue={setChannelUssageYear}
              />
              <Dropdown
                data={monthData}
                rangeValue={channelUssageMonth}
                setRangeValue={setChannelUssageMonth}
              />
            </div>
          </div>

          {isLoadingChannelData ? (
            <div className={styles.loaderContainer}>
              <img src={Loader} alt="loader" />
            </div>
          ) : channelUssageData?.amount ? (
            <Chart
              chartType="PieChart"
              width="100%"
              height="300px"
              data={channelUssageData?.amount}
              options={options}
            />
          ) : (
            <div className={styles.nodataContainer}>
              <h1>No Data</h1>
            </div>
          )}

          <div className={styles.usageCountContainer}>
            <h5 className={styles.usuageCountText}>Usage Count</h5>
            <div className={styles.usageCountInnerContainer}>
              {channelUssageData?.usage_count?.map((channel, index) => (
                <div className={`${styles[`usuageCount${index + 1}`]}`} key={index}>
                  <h5 className={styles.usuageTitle}>
                    {channel?.channel_name}
                  </h5>
                  <p className={styles.usuageNumber}>
                    {channel?.usage_count
                      ? parseInt(channel?.usage_count, 10)?.toLocaleString()
                      : "0"}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.pieContainer}>
          <div>
            <div className={styles.barChartTop}>
              <h4>Redemption Chart</h4>
              <p>View all redemption chart here</p>
            </div>
            <div className={styles.dropdownContainer}>
              <Dropdown
                data={DropdownYear}
                rangeValue={redemptionYear}
                setRangeValue={setRedemptionYear}
              />
              <Dropdown
                data={monthData}
                rangeValue={redemptionMonth}
                setRangeValue={setRedemptionMonth}
              />
            </div>
          </div>

          {isLoadingRedemption ? (
            <div className={styles.loaderContainer}>
              <img src={Loader} alt="loader" />
            </div>
          ) : redemptionData?.amount ? (
            <Chart
              chartType="PieChart"
              width="100%"
              height="300px"
              data={redemptionData?.amount}
              options={RedemptionOptions}
            />
          ) : (
            <div className={styles.nodataContainer}>
              <h1>No Data</h1>
            </div>
          )}
        </div>
      </div>

      {/* ENROLLMENT REPORT */}
      <div className={styles.barChartContainer}>
        <div className={styles.barChartTopContainer}>
          <div className={styles.barChartTop}>
            <h4>Enrollment Report</h4>
            <p>This a graph that shows all the enrollment done</p>
          </div>
          <Dropdown
            data={DropdownYear}
            rangeValue={enrolmentReportYear}
            setRangeValue={setEnrolmentReportYear}
          />
        </div>

        {isLoadingEnrolment ? (
          <div className={styles.loaderContainer}>
            <img src={Loader} alt="loader" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={barChartStyling}
              margin={{ top: 5, right: 10, left: 20, bottom: 5 }}
              height={250}
              data={enrolmentReport}
            >
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="Point" name="Count" fill="#003B65" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      <div className={styles.pieChartContainer}></div>
    </div>
  );
};

export default Dashboard;